import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useScrollAnimation from '../../../hooks/useScrollAnimation';
import { AnimatedSection } from '../../../components/common/AnimatedSection';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #ffffff;
  padding-top: 10%;
  padding-bottom: 8rem;
  @media (max-width: 768px) {
    padding-top: 30%;
  }
`;
const Container = styled.div`
  max-width: 1200px; margin: 0 auto; padding: 0 3rem;
`;
const PageHeader = styled.div`
  text-align: center; padding: 3rem 0;
`;
const PageTitle = styled.h1`
  font-size: 2rem; font-weight: 700; color: #111; margin-bottom: 1.5rem;
`;
const PageSubtitle = styled.p`
  font-size: 1.1rem; color: #6b7280;
`;
const SectionBox = styled.div`
  border: 1px solid #f3f4f6; border-radius: 12px; padding: 3rem; background: #f9fafb;
`;
const FormGroup = styled.div`
  display: flex; flex-direction: column; margin-bottom: 1.25rem;
`;
const Label = styled.label`
  font-weight: 600; margin-bottom: 0.5rem;
  .required { color: #ef4444; margin-left: 0.25rem; }
`;
const Input = styled.input`
  padding: 0.75rem 1rem; border: 1px solid #d1d5db; border-radius: 8px; font-size: 1rem;
`;
const SubmitButtonWrapper = styled.div`
  display: flex; justify-content: center; margin-top: 2rem;
`;
const SubmitButton = styled.button`
  background: #3b82f6; color: #fff; padding: 0.8rem 2rem; border: none;
  border-radius: 9999px; font-weight: 600; cursor: pointer;
  &:hover { background: #2563eb; }
`;
const ErrorMsg = styled.div`
  color: #b91c1c; margin-top: 0.75rem; text-align: center;
`;

export default function CheckReport() {
  const [headerRef, headerVisible] = useScrollAnimation();
  const [formRef, formVisible] = useScrollAnimation();
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const API = process.env.REACT_APP_API_BASE || 'http://localhost:8080';

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr('');
    if (loading) return;
    const fd = new FormData(e.currentTarget);
    const loginId = fd.get('loginId')?.toString().trim();
    const password = fd.get('password')?.toString();

    if (!loginId) return setErr('제보확인 아이디를 입력해 주세요.');
    if (!password) return setErr('비밀번호를 입력해 주세요.');

    try {
      setLoading(true);
      const res = await fetch(`${API}/api/reports/anonymous/check`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ loginId, password }),
      });
      if (!res.ok) {
        const text = await res.text();
        throw new Error(text || '조회 실패');
      }
      const data = await res.json(); // { referenceId, title, status, actionNotes, ... }
      // 성공: 결과 페이지로 이동
      window.location.assign(`/report/result/${encodeURIComponent(data.referenceId)}`);
    } catch (e1) {
      setErr('아이디/비밀번호가 올바르지 않거나 조회할 수 없습니다.');
      console.error(e1);
    } finally {
      setLoading(false);
    }
  };

  return (
      <PageContainer>
        <Container>
          <AnimatedSection ref={headerRef} isVisible={headerVisible} animation="fadeInUp">
            <PageHeader>
              <PageTitle>익명 제보 조회</PageTitle>
              <PageSubtitle>제보 당시 입력하신 아이디와 비밀번호로 결과를 확인할 수 있습니다.</PageSubtitle>
            </PageHeader>
          </AnimatedSection>

          <AnimatedSection ref={formRef} isVisible={formVisible} animation="fadeInUp" delay="0.2s">
            <form onSubmit={onSubmit} noValidate>
              <SectionBox>
                <FormGroup>
                  <Label>제보확인 아이디<span className="required">*</span></Label>
                  <Input name="loginId" type="text" placeholder="제보확인 아이디를 입력해 주세요." autoComplete="username" />
                </FormGroup>
                <FormGroup>
                  <Label>제보확인 비밀번호<span className="required">*</span></Label>
                  <Input name="password" type="password" placeholder="비밀번호를 입력해 주세요." autoComplete="current-password" />
                </FormGroup>
                {err && <ErrorMsg>{err}</ErrorMsg>}
                <SubmitButtonWrapper>
                  <SubmitButton type="submit">{loading ? '조회 중...' : '조회하기'}</SubmitButton>
                </SubmitButtonWrapper>
              </SectionBox>
            </form>
          </AnimatedSection>
        </Container>
      </PageContainer>
  );
}
